// internal-deps
import { getBridgeSdk } from "@swiggy-private/checkout-core";

// constants
import { PAYMENT_FEEDBACK_SHOWN, PAYMENT_FEEDBACK_URL } from "@payment-client/constants/PaymentFeedback";

//internal-deps
import { STORAGE_TYPES } from "@swiggy-private/native-bridge";

export const getPaymentFeedbackFlag = async (): Promise<boolean | undefined> => {
    try {
        const response = await getBridgeSdk().storage({
            type: STORAGE_TYPES.GET,
            data: {
                [PAYMENT_FEEDBACK_SHOWN]: "",
            },
        });
        const paymentFeedbackShownTime = response?.data[PAYMENT_FEEDBACK_SHOWN];
        if (paymentFeedbackShownTime == null) {
            return Promise.resolve(true);
        }

        // checking if feedback is shown once in last 30 days
        const dateOffset = 24 * 60 * 60 * 1000 * 30; // 30 days
        if (Date.now() - Number(paymentFeedbackShownTime) > dateOffset) {
            // deletes the flag
            getBridgeSdk().storage({
                type: STORAGE_TYPES.DELETE,
                data: {
                    [PAYMENT_FEEDBACK_SHOWN]: "",
                },
            });

            return Promise.resolve(false);
        }

        return Promise.resolve(true);
    } catch (_) {
        return Promise.resolve(true);
    }
};

export const updatePaymentFeedbackFlag = async (): Promise<void> => {
    getBridgeSdk().storage({
        type: STORAGE_TYPES.SAVE,
        data: {
            [PAYMENT_FEEDBACK_SHOWN]: String(Date.now()),
        },
    });
};

export const getFeedbackUrl = (): string => {
    if (typeof window !== "undefined") {
        return window?.__PAYMENT_FEEDBACK_URL__ || PAYMENT_FEEDBACK_URL;
    }

    return PAYMENT_FEEDBACK_URL;
};
